<div class="row text-center">
  <div class="col">
    <div class="header-icon full-icon">
      <img src="./assets/img/images/edit-information-icon.svg" alt="edit icon"/>
    </div>
    <h1 class="title-copy margin-bottom mb24">{{ 'EDIT_POLICY' | translate }}</h1> 
  </div>
</div>
<app-edit-policy-form [inputs]="editPolicyInfo"></app-edit-policy-form>
  <div class="row text-center mb16">
    <div class="col">
      <mapfre-modal 
      [modalOptions]="whereToFindModalOptions">
      <div class="modal-body no-padding-top">
        <hr class="margin-bottom mb24" />
        <div class="margin-bottom mb8">
          {{ 'NEW_FORMAT' | translate}}
        </div>
        <div class="margin-bottom mb24">
          <img src="./assets/img/images/new_format.png" alt="new format">
        </div>

        <div class="margin-bottom mb8">
          {{ 'CLASSIC_FORMAT' | translate}}
        </div>
        <div class="margin-bottom mb24">
          <img src="./assets/img/images/find-policy-image.png" alt="find policy">
        </div>
      </div>
    </mapfre-modal>
    </div>
  </div>
<div class="row text-center margin-top mt24">
  <div class="col">
      <mapfre-button
      additionalClasses="link-button red-link small w-100 button-border-red"
      [backIcon]="'./assets/img/icons/back-arrow-red.png'"
      [iconClasses]="'align-middle'"
      [routerLink]="['/signup', 'add-policy']"
      [showIconsCustom]="true"
    >  {{ 'BACK' | translate }}
    </mapfre-button>    
  </div>
</div>